import React from 'react';
import { NavBar, List, Avatar, Dialog } from 'antd-mobile'

import { 
    BodyView, 
    ListView, 
    EllipsisView
} from "../factory/ViewUtil";

import { 
    SecurityIcon,
    CurrencyIcon,
    LanguageIcon,
    ContactIcon,
    AboutIcon
 } from "../icons";
 import { AppOutline } from 'antd-mobile-icons'

import { CellCardView } from "../factory/CellViews";
import { avatarData, logoutClear } from "../../NetworkFactory";

const MeViewController = ({goback, navpush, user, t}) => {

    const logout = () => {
        Dialog.confirm({
            content : <div style={{textAlign : 'center', fontWeight : 'bold', fontSize : '17px'}}>Logout will not delete any data. You can still log in with this account.</div>,
            cancelText : 'Cancel',
            closeOnMaskClick: true,
            confirmText : <div style={{color : 'red'}}>Logout</div>,
            onConfirm: () => {
                logoutClear()
                navpush('/', true)
            }
        })
    };
    const HeaderView = () => {
        return (
            <div onClick={()=> {navpush('./profile')}} className='headerBackground' style={{
                padding : '15px',
                borderRadius : '16px',
                display: 'flex',
                alignItems : 'center',
                margin : '15px 0'
                }}>
                <Avatar src={avatarData()}  style={{'--size' : '60px', '--border-radius' : '30px'}}/>
                <div style={{margin : '0 15px'}}>
                    <EllipsisView style={{fontWeight : 'bold'}} content={user.name || 'Unknown'}/>
                    <EllipsisView style={{
                        fontSize : '14px',
                        borderRadius : '100px', 
                        border : '1px #FFF solid', 
                        padding : '0 6px'}} content={user.email}/>
                </div>
            </div>
        );
    }
    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>{t('me')}</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <ListView>
                    <List.Item arrowIcon={false}><HeaderView/></List.Item>
                    <CellCardView onClick={()=> {navpush('/app')}} prefix={<AppOutline fontSize={22} color='#0E1C39'/>}>{t('app_download')}</CellCardView>
                    <CellCardView onClick={()=> {navpush('./security')}} prefix={<SecurityIcon/>}>{t('security_center')}</CellCardView>
                    <CellCardView prefix={<CurrencyIcon/>} extra='USD'>{t('usd')}</CellCardView>
                    <CellCardView prefix={<LanguageIcon/>} extra='English'>Languages</CellCardView>
                    {/* <CellCardView onClick={()=> {navpush('/languages')}} prefix={<LanguageIcon/>} extra={t('language')}>{t('languages')}</CellCardView> */}
                    <CellCardView onClick={()=> {navpush('/chat')}} prefix={<ContactIcon/>}>{t('feedback')}</CellCardView>
                    <CellCardView onClick={()=> {navpush('./about')}} prefix={<AboutIcon/>}>{t('about')}</CellCardView>
                    <CellCardView onClick={logout} style={{fontWeight : 'bold', textAlign : 'center'}}>{t('logout')}</CellCardView>
                </ListView>
            </BodyView>
        </>
    );
}
export default React.memo(MeViewController)